var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoteAdd = function SvgNoteAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3831_191030",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3831_191030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 29.85V34.8C22.5 35.225 22.6447 35.5812 22.934 35.8685C23.223 36.1562 23.5813 36.3 24.009 36.3C24.4363 36.3 24.7917 36.1562 25.075 35.8685C25.3583 35.5812 25.5 35.225 25.5 34.8V29.85H30.5C30.925 29.85 31.2813 29.7053 31.569 29.416C31.8563 29.127 32 28.7687 32 28.341C32 27.9137 31.8563 27.5583 31.569 27.275C31.2813 26.9917 30.925 26.85 30.5 26.85H25.5V21.85C25.5 21.425 25.3553 21.0687 25.066 20.781C24.777 20.4937 24.4187 20.35 23.991 20.35C23.5637 20.35 23.2083 20.4937 22.925 20.781C22.6417 21.0687 22.5 21.425 22.5 21.85V26.85H17.5C17.075 26.85 16.7188 26.9947 16.4315 27.284C16.1438 27.573 16 27.9313 16 28.359C16 28.7863 16.1438 29.1417 16.4315 29.425C16.7188 29.7083 17.075 29.85 17.5 29.85H22.5ZM11 44C10.2 44 9.5 43.7 8.9 43.1C8.3 42.5 8 41.8 8 41V7C8 6.2 8.3 5.5 8.9 4.9C9.5 4.3 10.2 4 11 4H27.8C28.2147 4 28.61 4.08333 28.986 4.25C29.362 4.41667 29.6833 4.63333 29.95 4.9L39.1 14.05C39.3667 14.3167 39.5833 14.638 39.75 15.014C39.9167 15.39 40 15.7853 40 16.2V41C40 41.8 39.7 42.5 39.1 43.1C38.5 43.7 37.8 44 37 44H11ZM27.55 14.8V7H11V41H37V16.3H29.05C28.625 16.3 28.2688 16.1562 27.9815 15.8685C27.6938 15.5812 27.55 15.225 27.55 14.8Z",
    fill: "#B6C2D6"
  }))));
};
export default SvgNoteAdd;